import { BusinessType, CountryList, SalesChannel } from "../../types";

type CountryListBusinessTypeMap = {
  [key in CountryList]: BusinessType[];
};

type CountryListSalesChannelMap = {
  [key in CountryList]: SalesChannel[];
};

export const countryListBusinessTypeMap: CountryListBusinessTypeMap = {
  Australia: [
    "Sole Trader",
    "Private Company",
    "Public Company",
    "Partnership",
    "Trust",
    "Other Incorporated Entity",
  ],
  Canada: ["Sole Proprietorship", "Corporation", "Partnership"],
  "New Zealand": [
    "Sole Trader",
    "Private Company",
    "Public Company",
    "Partnership",
    "Associations, Clubs & Societies",
    "Trust",
  ],
  "United Kingdom": [
    "Sole Trader",
    "Private Company",
    "Public Limited Company",
    "Limited Liability Partnership",
    "Charity and Not For Profit",
    "Trust",
  ],
  "United States": ["Sole Proprietorship", "Corporation", "LLC", "Partnership"],
};

export const countryListSalesChannelMap: CountryListSalesChannelMap = {
  Australia: ["Online Only", "In-store Only", "Online and In-store"],
  Canada: ["Online Only"],
  "New Zealand": ["Online Only", "In-store Only", "Online and In-store"],
  "United Kingdom": ["Online Only", "In-store Only", "Online and In-store"],
  "United States": ["Online Only", "In-store Only", "Online and In-store"],
};
